(() => {
  const instances = new WeakMap();

  const initComparison = (scope = document) => {
    scope.querySelectorAll('[data-comparison]').forEach((section) => {
      if (instances.has(section)) return;

      const scroller = section.querySelector('.pdp-comparison__scroller');
      const scrollbar = section.querySelector('[data-comparison-scrollbar]');
      const thumb = section.querySelector('[data-comparison-scrollbar-thumb]');
      if (!(scroller instanceof HTMLElement) || !(scrollbar instanceof HTMLElement) || !(thumb instanceof HTMLElement)) return;

      let frame = 0;
      const updateScrollbar = () => {
        frame = 0;
        const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const hasOverflow = maxScroll > 0;
        scrollbar.hidden = !hasOverflow;
        if (!hasOverflow) return;

        const trackWidth = scrollbar.clientWidth;
        const thumbWidth = Math.max(24, trackWidth * (scroller.clientWidth / scroller.scrollWidth));
        const maxOffset = Math.max(0, trackWidth - thumbWidth);
        const offset = maxScroll ? (scroller.scrollLeft / maxScroll) * maxOffset : 0;
        thumb.style.setProperty('--comparison-scrollbar-thumb-width', `${thumbWidth}px`);
        thumb.style.setProperty('--comparison-scrollbar-thumb-offset', `${offset}px`);
      };
      const scheduleScrollbarUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(updateScrollbar);
      };
      const resizeObserver = typeof ResizeObserver === 'function'
        ? new ResizeObserver(scheduleScrollbarUpdate)
        : null;

      section.classList.add('has-comparison-scrollbar');
      scroller.addEventListener('scroll', scheduleScrollbarUpdate, { passive: true });
      resizeObserver?.observe(scroller);
      updateScrollbar();

      instances.set(section, () => {
        scroller.removeEventListener('scroll', scheduleScrollbarUpdate);
        resizeObserver?.disconnect();
        if (frame) window.cancelAnimationFrame(frame);
      });
    });
  };

  const unloadComparison = (scope) => {
    scope.querySelectorAll('[data-comparison]').forEach((section) => {
      const cleanup = instances.get(section);
      if (cleanup) cleanup();
      instances.delete(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initComparison());
  document.addEventListener('shopify:section:load', (event) => initComparison(event.target));
  document.addEventListener('shopify:section:unload', (event) => unloadComparison(event.target));
})();
